// extracted by mini-css-extract-plugin
export default {"grid":"CategoryGrid_grid__aHrEl","card":"CategoryGrid_card__zFpbs","iconBox":"CategoryGrid_iconBox__xZl4C","name":"CategoryGrid_name__C1bFf","count":"CategoryGrid_count__p-tph"};